/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Pm_To_SaveInputs */

const cs_pm_to_save = /** @type {(inputs: Pm_To_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`K uložení: ${i?.n}`)
};

const en_pm_to_save = /** @type {(inputs: Pm_To_SaveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To save: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "To save: {n}" |
*
* @param {Pm_To_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_to_save = /** @type {((inputs: Pm_To_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_To_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_to_save(inputs)
	return cs_pm_to_save(inputs)
});